import React, { FC, useCallback, useRef, useState } from 'react';
import { functionNoop } from 'src/utils/function/noop';
import { JourneyMenuPropsInterface } from 'src/common/JourneyMenu';
import { DashboardLibrarySyncedStepsOptionsMenu } from './options-menu';
import { EditorConfirmPanel } from 'src/editor/confirm-panel';

interface DashboardLibrarySyncedStepsOptionsProps extends Pick<JourneyMenuPropsInterface, 'offset' | 'placement'> {
  nestedMenuOffset?: JourneyMenuPropsInterface['offset'];
  onMenuOpen: () => void;
  onMenuClose: () => void;
  onEdit: () => void;
  onDelete: () => void;
  onRefreshThumbnail: () => void;
  renderMenuOrigin: (onClick: () => void) => any;
}

export type EditorContentActivePanelTypes = 'delete' | 'security' | 'sync-step' | 'edit' | 'copy' | 'refresh-thumbnail';

export const DashboardLibrarySyncedStepsOptions: FC<DashboardLibrarySyncedStepsOptionsProps> = ({
  onMenuOpen,
  onMenuClose,
  onEdit,
  onDelete,
  placement,
  offset,
  nestedMenuOffset,
  renderMenuOrigin,
  onRefreshThumbnail,
}) => {
  const settingsMenuOpenRef = useRef(functionNoop);
  const settingsMenuCloseRef = useRef(functionNoop);

  const deletePanelOpenRef = useRef(functionNoop);
  const deletePanelCloseRef = useRef(functionNoop);

  const [isDeleteConfirmPanelOpen, setIsDeleteConfirmPanelOpen] = useState(false);

  const onMenuClicked = () => {
    settingsMenuOpenRef.current();
  };

  const onBack = () => {
    setIsDeleteConfirmPanelOpen(false);
    deletePanelCloseRef.current();

    setTimeout(onMenuClicked, 50);
  };

  const onClosePanel = () => {
    setIsDeleteConfirmPanelOpen(false);
    onMenuClose();
  };

  const onDeleteClick = useCallback(() => {
    setIsDeleteConfirmPanelOpen(true);
  }, []);

  const onDeleteConfirm = useCallback(() => {
    onDelete();
    deletePanelCloseRef.current();
    settingsMenuCloseRef.current();
  }, [onDelete]);

  if (isDeleteConfirmPanelOpen) {
    return (
      <EditorConfirmPanel
        renderOrigin={() => renderMenuOrigin(onMenuClicked)}
        offset={nestedMenuOffset || offset}
        placement={placement}
        openRef={deletePanelOpenRef}
        closeRef={deletePanelCloseRef}
        copy='Deleting this Synced Step is an irreversible action. Deleting this will detach this Step in other Journeys.'
        confirmCopy='Yes, delete'
        denyCopy='No, keep'
        onOpen={onMenuOpen}
        onClose={onClosePanel}
        onConfirm={onDeleteConfirm}
        onDeny={onClosePanel}
        onBack={onBack}
      />
    );
  }

  return (
    <DashboardLibrarySyncedStepsOptionsMenu
      openRef={settingsMenuOpenRef}
      closeRef={settingsMenuCloseRef}
      onOpen={onMenuOpen}
      offset={offset}
      placement={placement}
      onClose={onMenuClose}
      renderOrigin={() => renderMenuOrigin(onMenuClicked)}
      onEdit={onEdit}
      onDelete={onDeleteClick}
      onRefreshThumbnail={onRefreshThumbnail}
    />
  );
};
